import React from "react";

const BloodQueenGift = () => {
  return <div>BloodQueenGift</div>;
};

export default BloodQueenGift;
